import { css } from 'styled-components';
import { Brand } from '@/domainLogic/index.ts';
import { Button } from '@lmn/design-system';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useTranslation } from '../../translations/Translation';
import OpenXModal from '../../search/components/Modal/OpenXModal';

export default function TSHExplanationDialog(props: {
  isOpen: boolean;
  onClose: () => void;
  onOpenByBrowserHistory?: () => void;
}) {
  const { isOpen, onClose, onOpenByBrowserHistory } = props;
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { imageBasePath } = localization;

  return (
    <OpenXModal
      isOpen={isOpen}
      isMobile={true}
      onClose={onClose}
      onCloseByBrowserHistory={onClose}
      onOpenByBrowserHistory={onOpenByBrowserHistory}
      fullScreen={false}
      brand={Brand.LASTMINUTE}
      aria-label={t('vacation.common.topsecret.explanation.link')}
      className="tsh-explanation-modal"
      id="tsh-explanation-modal"
      bodyBackgroundColor="backgroundPage"
    >
      <div
        css={`
          display: flex;
          flex-direction: column;
          row-gap: 16px;
          align-items: center;
          justify-content: center;
        `}
      >
        <div
          css={`
            display: flex;
            align-items: center;
            justify-content: center;
            column-gap: 8px;
            height: 100px;
            width: 100%;
            z-index: 0;
            background-image: url('${imageBasePath}tsh-pattern.png');
            background-repeat: repeat-x;
            border-radius: 8px;
            background-size: cover;
          `}
        >
          {}
          <img
            css={`
              width: 52px;
              height: 52px;
            `}
            src={`${imageBasePath}logo-image-tsh-white.svg`}
            alt="tsh-icon-logo"
          />
          {}
          <img
            css={`
              width: 128px;
              height: 42px;
            `}
            src={`${imageBasePath}logo-tsh-2-lines.svg`}
            alt="tsh-icon-logo-text"
          />
        </div>
        <div
          css={css`
            font-size: ${(p) => p.theme.commons.font.sizes.base};
          `}
          /* eslint-disable-next-line react/no-danger */
          dangerouslySetInnerHTML={{ __html: filterXSS(t('vacation.select.details.tsh.explanation')) }}
        />
        <Button
          variant="primary"
          onClick={onClose}
          css={`
            width: 100%;
          `}
        >
          {t('vacation.select.details.tsh.cta')}
        </Button>
      </div>
    </OpenXModal>
  );
}
